"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.obtenirRouteCourante = void 0;

var _reactRouter = require("react-router");

var obtenirRouteCourante = function obtenirRouteCourante(props) {
  var _props$routes$filter$;

  var chemin = props.location.pathname.replace(/\/$/, '');
  return (_props$routes$filter$ = props.routes.filter(function (route) {
    return !!(0, _reactRouter.matchPath)(chemin, {
      path: route.chemin,
      exact: true,
      strict: false
    });
  }).find(function (e) {
    return true;
  })) !== null && _props$routes$filter$ !== void 0 ? _props$routes$filter$ : props.routes.filter(function (route) {
    return route.parent === null;
  }).find(function (e) {
    return true;
  });
};

exports.obtenirRouteCourante = obtenirRouteCourante;